import { inputTypes } from 'components/common/FormElements/Input'
import { convertStatesToOptions } from 'helpers/options'
import { STATE_OPTIONS } from 'constant'
import {
  NAME_FIELD,
  PHONE_FIELD,
  EMAIL_FIELD,
  ZIP_CODE_FIELD,
  SUBJECT_FIELD,
  COMMENTS_FIELD,
  SUBJECT_EMAILS_OPTIONS,
  CONTACT_SUBJECT_EMAILS_OPTIONS,
  ADDRESS_FIELD,
  BEST_TIME_TO_CALL_FIELD,
  CITY_FIELD,
  PHONE_EXTENSION_FIELD,
  NUMBERS_OF_VEHICLES_IN_FLEET_FIELD,
  STATE_FIELD,
  TYPE_OF_COMPANY_FIELD,
  STORE_LOCATION,
  DATE_OF_SERVICE,
  INVOICE_OR_ESTIMATE,
  SERVICE_DETAILS_HINT_ID
} from './constants'

export default {
  subject: {
    label: 'Subject',
    name: SUBJECT_FIELD,
    inputType: inputTypes.SELECT_DROPDOWN_INPUT,
    options: SUBJECT_EMAILS_OPTIONS,
    isSearchable: false,
    required: true
  },
  name: {
    label: 'Name*',
    name: NAME_FIELD,
    required: true
  },
  phone: {
    label: 'Phone Number*',
    name: PHONE_FIELD,
    required: true
  },
  email: {
    label: 'Email*',
    name: EMAIL_FIELD,
    required: true
  },
  zipCode: {
    label: 'Zip Code*',
    name: ZIP_CODE_FIELD,
    required: true
  },
  contactSubject: {
    label: 'Subject*',
    name: SUBJECT_FIELD,
    inputType: inputTypes.SELECT_DROPDOWN_INPUT,
    options: CONTACT_SUBJECT_EMAILS_OPTIONS,
    isSearchable: false,
    required: true
  },
  storeLocation: {
    label: 'Store Address',
    name: STORE_LOCATION,
    'aria-describedby': SERVICE_DETAILS_HINT_ID,
    disabled: true
  },
  dateOfService: {
    label: 'Date of Service',
    name: DATE_OF_SERVICE,
    inputType: inputTypes.COMMON_DATE_PICKER,
    'aria-describedby': SERVICE_DETAILS_HINT_ID
  },
  invoiceOrEstimate: {
    label: 'Invoice # or Estimate #',
    name: INVOICE_OR_ESTIMATE,
    'aria-describedby': SERVICE_DETAILS_HINT_ID
  },
  comments: {
    label: 'Comments*',
    name: COMMENTS_FIELD,
    inputType: inputTypes.TEXTAREA_INPUT,
    required: true
  },
  address: {
    label: 'Address',
    name: ADDRESS_FIELD
  },
  city: {
    label: 'City',
    name: CITY_FIELD
  },
  state: {
    label: 'State',
    name: STATE_FIELD,
    inputType: inputTypes.SELECT_DROPDOWN_INPUT,
    options: convertStatesToOptions(STATE_OPTIONS)
  },
  phoneExtension: {
    label: 'Ext',
    name: PHONE_EXTENSION_FIELD
  },
  bestTimeToCall: {
    label: 'Best Time To Call',
    name: BEST_TIME_TO_CALL_FIELD
  },
  numberOfVehicles: {
    label: 'Number of Vehicles in Fleet',
    name: NUMBERS_OF_VEHICLES_IN_FLEET_FIELD
  },
  typeOfCompany: {
    label: 'Type of Company',
    name: TYPE_OF_COMPANY_FIELD
  }
}
